import { Children, Component } from 'react';
import styled from 'styled-components';
import { BaseLayout } from '../Layout/BaseLayout';
import { IBaseLayoutProps } from '../Layout/IBaseLayoutProps';

const LayoutElement = styled.div`
  display: flex;
  flex: 1;
  justify-content: ${(props: any) => (props.align === 'center' ? 'center' : 'flex-start')};
  flex-flow: row wrap;
  overflow: visible;

  & > * {
    min-width: ${({ minWidth }: any) => minWidth || 300}px;
    max-width: ${({ maxWidth }: any) => maxWidth || 600}px;
    margin-right: 50px;
    margin-bottom: 20px;
  }

  & > *:last-child {
    margin-right: 0px;
    margin-bottom: 0px;
  }
` as any;

export type SingleColumnLayoutAlignment = 'left' | 'center';

interface IProps extends IBaseLayoutProps {
  /** Column alignment.  Either "left" (default) or "center" */
  align?: SingleColumnLayoutAlignment;
  /** The max width of the column in pixels. Defaults to 600 */
  maxWidth?: number;
  /** The min width of the column in pixels. Defaults to 300 */
  minWidth?: number;
}

export class SingleColumnLayout extends Component<IProps> {
  public render() {
    return (
      <BaseLayout {...this.props} data-testid="SingleColumnLayout">
        <LayoutElement align={this.props.align} minWidth={this.props.minWidth} maxWidth={this.props.maxWidth}>
          {Children.only(this.props.children)}
        </LayoutElement>
      </BaseLayout>
    );
  }
}
